export default "__VITE_ASSET__a09cec22__"